import request from '@/utils/request'

export function statics(params) {
	return request({
		url: 'project/statistics',
		method: 'get',
		params
	})
}
export function staticsSub(params) {
	return request({
		url: 'project/statistics/sub',
		method: 'get',
		params
	})
}